// Number formatting for the admin dashboard (Indian grouping: 1,00,000)

const inr = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});
const num = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });

export function formatCurrency(value) {
  return value == null ? "—" : inr.format(value);
}

export function formatNumber(value) {
  return value == null ? "—" : num.format(value);
}

export function formatPercent(value) {
  return value == null ? "—" : `${Number(value).toFixed(1)}%`;
}

export function formatRating(value) {
  return value == null ? "—" : Number(value).toFixed(1);
}

// Short form for axis ticks: ₹25L, ₹1.2Cr, ₹40K
export function formatCompactCurrency(value) {
  const abs = Math.abs(value);
  const trim = (n) => String(Number(n.toFixed(1)));
  if (abs >= 1e7) return `₹${trim(value / 1e7)}Cr`;
  if (abs >= 1e5) return `₹${trim(value / 1e5)}L`;
  if (abs >= 1e3) return `₹${trim(value / 1e3)}K`;
  return `₹${value}`;
}

export function formatCompactNumber(value) {
  const abs = Math.abs(value);
  const trim = (n) => String(Number(n.toFixed(1)));
  if (abs >= 1e5) return `${trim(value / 1e5)}L`;
  if (abs >= 1e3) return `${trim(value / 1e3)}K`;
  return String(value);
}

export const formatters = {
  currency: formatCurrency,
  number: formatNumber,
  percent: formatPercent,
  rating: formatRating,
};
